import { ScreenScanPage } from '@hq/screen-scan';
import { hq } from '../session';

/**
 * 申请码确认（PC 端，OPS 门户）：
 * 输入大屏上显示的 12 位申请码（4-4-4 三段），当前登录账号直接确认；
 * 可搜索/筛选租户与机构，决定这块屏显示谁的数据（需 sys:config:manage）。
 */
export default function ScreenScan() {
  return <ScreenScanPage hq={hq} />;
}
